module.exports = __webpack_public_path__ + "static/media/MTN.bfcdd790.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/MTN.svg
// module id = 379
// module chunks = 25